(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lohnr-product-ugc-v6"] && !Shopify.designMode) return;
  try {
    (() => {
  const tag = 'lohnr-product-ugc-v6';
  if (customElements.get(tag)) return;

  class LohnrProductUGCV6 extends HTMLElement {
    connectedCallback() {
      if (this._initFrame || this._controller) return;
      this._initFrame = requestAnimationFrame(() => {
        this._initFrame = null;
        if (this.isConnected) this.initialize();
      });
    }

    initialize() {
      this.track = this.querySelector('[data-lugc-track]');
      this.dialog = this.querySelector('[data-lugc-dialog]');
      this.items = Array.from(this.querySelectorAll('[data-lugc-item]'));
      if (!this.track || !this.dialog || !this.items.length) return;
      this.stage = this.querySelector('[data-lugc-stage]');
      this.status = this.querySelector('[data-lugc-now]');
      this.error = this.querySelector('[data-lugc-error]');
      this.nav = this.querySelector('[data-lugc-rail-nav]');
      this.index = 0;
      this._controller = new AbortController();
      const options = { signal:this._controller.signal };
      this.addEventListener('click', (event) => this.handleClick(event), options);
      this.track.addEventListener('scroll', () => this.scheduleNav(), { ...options, passive:true });
      this.track.addEventListener('keydown', (event) => this.handleRailKey(event), options);
      this.dialog.addEventListener('close', () => {
        if (!this.dialog.open) this.cleanupPlayer();
      }, options);
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.close();
      }, options);
      this.dialog.addEventListener('keydown', (event) => {
        // Keep V6's gallery keyboard handlers from handling the video dialog.
        event.stopPropagation();
      }, options);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.video?.pause();
      }, options);
      document.addEventListener('lohnr:ugc-open', (event) => {
        if (event.detail?.owner !== this) this.close();
      }, options);
      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target.contains(this)) this.close();
      }, options);
      if ('ResizeObserver' in window) {
        this._resizeObserver = new ResizeObserver(() => this.scheduleNav());
        this._resizeObserver.observe(this.track);
      } else {
        window.addEventListener('resize', () => this.scheduleNav(), options);
      }
      this.updateNav();
    }

    disconnectedCallback() {
      cancelAnimationFrame(this._initFrame);
      cancelAnimationFrame(this._navFrame);
      this._initFrame = null;
      this._navFrame = null;
      this._resizeObserver?.disconnect();
      this._controller?.abort();
      this._controller = null;
      if (this.dialog?.open) this.dialog.close();
      this.cleanupPlayer();
    }

    handleClick(event) {
      const target = event.target.closest('a,button');
      if (!target || !this.contains(target)) return;
      if (target.matches('[data-lugc-open]')) {
        // Preserve normal link behavior without dialog support or for modifier clicks.
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0 || typeof this.dialog.showModal !== 'function') return;
        event.preventDefault();
        event.stopPropagation();
        this.open(this.items.indexOf(target.closest('[data-lugc-item]')), target);
      } else if (target.matches('[data-lugc-scroll]')) {
        event.preventDefault();
        event.stopPropagation();
        this.scrollRail(Number(target.dataset.lugcScroll));
      } else if (target.matches('[data-lugc-close]')) {
        event.preventDefault();
        event.stopPropagation();
        this.close();
      } else if (target.matches('[data-lugc-step]')) {
        event.preventDefault();
        event.stopPropagation();
        this.showVideo(this.index + Number(target.dataset.lugcStep));
      } else if (target.matches('[data-lugc-retry]')) {
        event.preventDefault();
        event.stopPropagation();
        this.showVideo(this.index);
      }
    }

    handleRailKey(event) {
      const anchor = event.target.closest('[data-lugc-open]');
      if (!anchor) return;
      const current = this.items.indexOf(anchor.closest('[data-lugc-item]'));
      const rtl = getComputedStyle(this.track).direction === 'rtl';
      let next = current;
      if (event.key === 'ArrowRight') next += rtl ? -1 : 1;
      else if (event.key === 'ArrowLeft') next += rtl ? 1 : -1;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = this.items.length - 1;
      else return;
      event.preventDefault();
      event.stopPropagation();
      const link = this.items[Math.max(0, Math.min(this.items.length - 1, next))].querySelector('[data-lugc-open]');
      link.focus({ preventScroll:true });
      link.scrollIntoView({ block:'nearest', inline:'nearest', behavior:'instant' });
    }

    scrollRail(direction) {
      const width = this.items[0].getBoundingClientRect().width;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const rtl = getComputedStyle(this.track).direction === 'rtl';
      this.track.scrollBy({ left:(rtl ? -1 : 1) * direction * (width + gap), behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }

    scheduleNav() {
      if (this._navFrame) return;
      this._navFrame = requestAnimationFrame(() => {
        this._navFrame = null;
        this.updateNav();
      });
    }

    updateNav() {
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const position = Math.abs(this.track.scrollLeft);
      this.nav.hidden = max <= 2;
      this.querySelector('[data-lugc-scroll="-1"]').disabled = position <= 2;
      this.querySelector('[data-lugc-scroll="1"]').disabled = position >= max - 2;
    }

    open(index, trigger) {
      document.dispatchEvent(new CustomEvent('lohnr:ugc-open', { detail:{ owner:this } }));
      this.trigger = trigger;
      if (!this.dialog.open) {
        this.dialog.showModal();
        this._scrollLock = {
          value:document.documentElement.style.getPropertyValue('overflow'),
          priority:document.documentElement.style.getPropertyPriority('overflow')
        };
        document.documentElement.style.setProperty('overflow', 'hidden');
      }
      this.showVideo(index);
    }

    showVideo(index) {
      if (!this.dialog.open) return;
      this.releaseVideo();
      this.index = Math.max(0, Math.min(this.items.length - 1, index));
      const item = this.items[this.index];
      this.stage.appendChild(item.querySelector('[data-lugc-template]').content.cloneNode(true));
      this.video = this.stage.querySelector('video');
      this.error.hidden = true;
      this.status.textContent = `${item.dataset.title} · ${this.index + 1} / ${this.items.length}`;
      this.querySelector('[data-lugc-step="-1"]').disabled = this.index === 0;
      this.querySelector('[data-lugc-step="1"]').disabled = this.index === this.items.length - 1;
      if (!this.video) { this.error.hidden = false; return; }
      const video = this.video;
      video.controls = true;
      video.setAttribute('aria-label', item.dataset.title);
      video.addEventListener('error', () => {
        if (this.video === video && this.dialog.open) this.error.hidden = false;
      }, { once:true });
      const playing = video.play();
      playing?.catch((error) => {
        if (this.video !== video || !this.dialog.open) return;
        // If sound playback is blocked, leave native controls available to the viewer.
        if (error.name !== 'NotAllowedError' && error.name !== 'AbortError') this.error.hidden = false;
      });
    }

    releaseVideo() {
      if (this.video) {
        this.video.pause();
        this.video.removeAttribute('src');
        this.video.querySelectorAll('source').forEach((source) => source.removeAttribute('src'));
        this.video.load();
        this.video = null;
      }
      this.stage?.replaceChildren();
    }

    close() {
      if (!this.dialog?.open) return;
      this.dialog.close();
      this.cleanupPlayer();
    }

    cleanupPlayer() {
      this.releaseVideo();
      if (this._scrollLock) {
        if (this._scrollLock.value) document.documentElement.style.setProperty('overflow', this._scrollLock.value, this._scrollLock.priority);
        else document.documentElement.style.removeProperty('overflow');
        this._scrollLock = null;
      }
      if (this.trigger?.isConnected && this.isConnected) this.trigger.focus({ preventScroll:true });
      this.trigger = null;
    }
  }

  customElements.define(tag, LohnrProductUGCV6);
})();
  } catch(e) { console.error(e); }
})();

})();
